import { render } from "./FactoryName.vue?vue&type=template&id=8a62bd78"
import script from "./FactoryName.vue?vue&type=script&lang=js"
export * from "./FactoryName.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__